import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {UrlService} from "../../service/url.service";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  showContactForm: boolean = false;
  previousUrl:string = "";

  constructor(private router: Router, private urlService: UrlService) { }

  ngOnInit(): void {
    this.urlService.previousUrl$.subscribe((previousUrl:string) =>  {
      this.previousUrl = previousUrl
    })
  }

  reload(){
    if(this.previousUrl === undefined){
      this.router.navigate(['/home'])
    }
    else{
      this.router.navigate([this.previousUrl])
    }
  }

  setShowContactForm(){
    this.showContactForm = true;
  }

}
